import * as React from 'react';
import { GraphData, ModalFilter, SlicerOptionType } from '../types';
import { SeriesOptionsType } from 'highcharts';
import GraphHeader from './GraphHeader';
import SlicerOptions from './SlicerOptions';
import { returnCleanedString } from '../helpers/format';

export interface GraphsContainerProps {
  selectedSegment?: any;
  marketFilters?: Array<ModalFilter | null>;
  legends?: Array<SeriesOptionsType>;
  parentRef?: any;
  data?: GraphData[] | undefined | null;
  showExportOptions: boolean;
  setShowExportOptions: (value: React.SetStateAction<boolean>) => void;
  fileName?: string;
  isSlicer?: boolean;
  sliceOptions?: SlicerOptionType[];
}

const GraphsContainer: React.FC<GraphsContainerProps> = ({
  selectedSegment,
  marketFilters,
  parentRef,
  data,
  setShowExportOptions,
  showExportOptions,
  children,
  isSlicer,
  sliceOptions
}) => {
  return (
    <div className="bg-white rounded-sm p-[18px]" ref={parentRef}>
      <GraphHeader
        selectedSegment={selectedSegment && returnCleanedString(selectedSegment)}
        graph={parentRef}
        data={data}
        marketFilters={marketFilters}
        showExportOptions={showExportOptions}
        setShowExportOptions={setShowExportOptions}
      />
      {isSlicer && (
        <div className="flex mt-6">
          <SlicerOptions variant="containerFullWidth" options={sliceOptions} onChange={() => null} />
        </div>
      )}
      <div className="bg-white pt-9 rounded-[2px] mb-2 relative">{children}</div>
    </div>
  );
};

export default GraphsContainer;
